const BASE_URL = 'peer_reference';

export const PEER_REFERENCE_ROUTES = {
  get: `${BASE_URL}/code/{magicLink}`,
  patch: `${BASE_URL}/code/{magicLink}`,
  post: `${BASE_URL}/code/{magicLink}`,
};
